import { ProductActionType } from '../action-types/productTypes';
import { ProductActions } from '../actions/productTypes';
import { Dispatch } from 'redux';

export const setContract = (contract: Contract) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_CONTRACT,
      payload: contract,
    });
  };
};

export const setPaypalNounce = (nounce: string) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_PAYPAL_NOUNCE,
      payload: nounce,
    });
  };
};

export const setPaypalToken = (token: string) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_PAYPAL_TOKEN,
      payload: token,
    });
  };
};

export const setCreditAccepted = (isAccepted: boolean) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_CREDIT_ACCEPTED,
      payload: isAccepted,
    });
  };
};

export const setPayPageHandles = (payPageHandles: PayPageHandles) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_PAY_PAGE_HANDLES,
      payload: payPageHandles,
    });
  };
};

export const setPrecontractualInfo = (infos: PrecontractualInfo) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_PRECONTRACTUAL_INFO,
      payload: infos,
    });
  };
};

export const setSelectedProduct = (plan: SinglePlan) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_SELECTED_PRODUCT,
      payload: plan,
    });
  };
};

export const setFilteredProductPlans = (plans: ProductPlan) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_FILTERED_PRODUCT_PLANS,
      payload: plans,
    });
  };
};

export const setProductPlans = (plans: ProductPlan) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_PRODUCT_PLANS,
      payload: plans,
    });
  };
};

export const setRecordOfAdviceUrl = (url: string) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_RECORD_OF_ADVICE_URL,
      payload: url,
    });
  };
};

export const setPreciItems = (items: Array<{ urlType: string }>) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_PRECI_ITEMS,
      payload: items,
    });
  };
};

export const setProductPlanLoaded = (productPlanLoaded: boolean) => {
  return (dispatch: Dispatch<ProductActions>) => {
    dispatch({
      type: ProductActionType.SET_PRODUCT_PLAN_LOADED,
      payload: productPlanLoaded,
    });
  };
};
